export default __webpack_public_path__ + "static/background-logo-7b7578c08277c8bea4cdf1485ea57fa9.svg";